import { Link, useNavigate, useParams } from 'react-router-dom'
import './LoginPage.css'

import { faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect, useState } from 'react'
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
import { changeEmail } from '../../store/store'


const LoginPage = ()=>{
  let navigate = useNavigate();
  let dispatch = useDispatch();

  const [emailInputStyle, setEmailInputStyle] = useState("");
  const [emailAlertStyle, setEmailAlertStyle] = useState("none");
  const [emailBtnStyle, setEmailBtnStyle] = useState(["","","none"]);

  const [formValue, setformValue] = useState({
    email: ''
  });

  const emailInputChage =(e)=>{
    let inputValue = e.target.value;
    var regExp=/([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    if (inputValue.match(regExp) != null) {  // 정규식을 만족했을때
      setEmailInputStyle("#36f");
      setEmailAlertStyle("none");
      setEmailBtnStyle(["#36f","pointer","auto"]);
    }
    else { // 정규식을 만족하지 않았을때
      setEmailInputStyle("#fe415c");
      setEmailAlertStyle("block");
      setEmailBtnStyle(["","","none"]);
    }
    if(inputValue.length === 0){ // 아무것도 안적었을때
      setEmailInputStyle("");
      setEmailAlertStyle("none");
      setEmailBtnStyle(["","","none"]);
    }
    setformValue({
      ...formValue,
      [e.target.name]: inputValue
    });
    // console.log(formValue);
  }

  const getMainPageData = async(e) =>{

    e.preventDefault();
    const url = 'https://prod.risingserver13forever.shop/app/login';
    // let emailData = {"email":"example@example.com"};
    const config = {"Content-Type": "application/json" };

    try{
      const data = await axios({
        method:'post',
        url : url,
        data : JSON.stringify(formValue),  // JSON.stringify(emailData)
        headers: config,
      })
      // console.log(data.data);
      if(data.data.code===1001){
        dispatch( changeEmail(formValue.email));
        navigate('/password');
      } else{
        dispatch( changeEmail(formValue.email));
        navigate('/signup');
      }
    }
    catch(err){
      alert(err);
    }
  }

  return(
    <div className='login-back'>
      <div className="login-content">
        <div className='login-logo'>
          <span>
            <svg viewBox="0 0 93 28" className='login-logo-svg'>
              <path d="M4.77051 23H8.68066L11.626 13.7578L14.5967 23H18.5068L22.874 9.28906H18.9639L16.4248 18.0996L13.4541 9.28906H9.79785L6.82715 18.0996L4.28809 9.28906H0.37793L4.77051 23ZM22.8486 16.1191C22.8486 19.6865 25.1084 23.3301 29.5264 23.3301C31.0371 23.3428 32.332 22.9111 33.3857 22.1621V23H36.9658V9.28906H33.3857V10.127C32.332 9.37793 31.0371 8.94629 29.5264 8.95898C25.1084 8.95898 22.8486 12.5518 22.8486 16.1191ZM26.3271 16.1191C26.3145 13.6689 27.9902 12.2725 29.9326 12.2598C31.8496 12.2725 33.3604 13.6309 33.3604 16.0938C33.3604 18.5693 31.8496 20.0166 29.9326 20.0039C27.9268 20.0166 26.3145 18.5693 26.3271 16.1191ZM39.1494 23H42.8564V15.1035C42.8564 13.5166 43.7832 12.2725 45.4209 12.2598C47.1855 12.2725 47.9346 13.4658 47.9346 15.002V23H51.6416V14.3418C51.6416 11.3457 50.0928 8.9209 46.6904 8.9082C45.2432 8.9209 43.6309 9.54297 42.7803 10.8887V9.28906H39.1494V23ZM52.708 12.5645H55.1963V18.9375C55.1963 21.6035 56.8594 23.3301 59.5381 23.3301C60.6172 23.3301 61.29 23.1396 61.6201 23V19.7754C61.4297 19.8516 60.9219 19.9023 60.4775 19.9023C59.4238 19.9023 58.8779 19.5088 58.8779 18.3027V12.5645H61.6201V9.28906H58.8779V4.69336L55.2471 6.2168V9.28906H52.708V12.5645ZM62.8389 16.1445C62.8389 20.0928 65.3652 23.3428 69.5166 23.3301C72.5381 23.3428 74.7217 21.6035 75.6865 19.0898L72.3857 18.4043C71.8398 19.585 70.8369 20.3594 69.5166 20.3594C67.752 20.3594 66.5586 18.9756 66.2666 17.1094H76.1436C76.1816 16.792 76.1943 16.4746 76.1943 16.1445C76.1943 11.9551 73.4395 8.95898 69.5166 8.95898C65.4414 8.95898 62.8389 12.1836 62.8389 16.1445ZM66.4443 14.5449C66.9014 13.1992 67.9932 12.2598 69.5166 12.2598C71.04 12.2598 72.1445 13.1992 72.6143 14.5449H66.4443ZM77.4131 16.1191C77.4131 20.1055 79.9395 23.3428 84.0908 23.3301C85.6016 23.3428 86.8965 22.8984 87.9502 22.1621V23L91.5049 23.0254V3.27148L87.874 4.69336V10.0762C86.7568 9.32715 85.4365 8.95898 84.0908 8.95898C80.0029 8.95898 77.4131 12.1201 77.4131 16.1191ZM80.8662 16.1191C80.8662 13.6562 82.542 12.2725 84.4717 12.2598C86.4141 12.2725 87.9121 13.6309 87.9248 16.0684C87.9121 18.5693 86.4141 20.0166 84.4717 20.0039C82.4912 20.0166 80.8662 18.5693 80.8662 16.1191Z" fill="var(--theme-palette-colors-black-100)"></path>
            </svg>
          </span>
        </div>
        <div className='login-title'>하나의 계정으로<br/>더욱 편리하게</div>
        <div className='login-sub-title'>원티드가 제공하는 서비스를<br/>하나의 계정으로 모두 이용할 수 있습니다.</div>
        <form className='login-form' onSubmit={getMainPageData}>
          <div className='email-text'>이메일</div>
          <input className='email-input' name='email' type='text' placeholder='이메일을 입력해주세요' style={{borderColor:emailInputStyle}}
            onChange={emailInputChage} />
          <p className='email-alert-p' style={{display:emailAlertStyle}} >올바른 이메일을 입력해주세요</p>
          <button className='email-form-btn' style={{backgroundColor:emailBtnStyle[0], cursor:emailBtnStyle[1], pointerEvents:emailBtnStyle[2]}}
            type='submit'> 
            이메일로 계속하기
          </button>
        </form>
        <div className='or'>또는</div>
        <div className='flex-row social-btn-box'>
          <button type="button" className='social-btn'>
            <span><svg className='social-logo' viewBox="0 0 57 56"><path d="M0.5 28C0.5 12.536 13.036 0 28.5 0C43.964 0 56.5 12.536 56.5 28C56.5 43.464 43.964 56 28.5 56C13.036 56 0.5 43.464 0.5 28Z" fill="black"></path><path d="M28.8182 19.359C30.0068 19.359 31.4968 18.5307 32.384 17.4264C33.1876 16.4256 33.7736 15.0279 33.7736 13.6302C33.7736 13.4404 33.7568 13.2506 33.7233 13.0953C32.4008 13.147 30.8104 14.0098 29.8561 15.1659C29.1028 16.046 28.4164 17.4264 28.4164 18.8413C28.4164 19.0484 28.4499 19.2555 28.4666 19.3245C28.5503 19.3418 28.6843 19.359 28.8182 19.359ZM24.6329 40.2381C26.2568 40.2381 26.9767 39.1165 29.0023 39.1165C31.0615 39.1165 31.5135 40.2036 33.3215 40.2036C35.0961 40.2036 36.2847 38.5126 37.4064 36.8561C38.6619 34.958 39.1809 33.0944 39.2144 33.0081C39.0972 32.9736 35.6988 31.5414 35.6988 27.5209C35.6988 24.0352 38.3773 22.465 38.528 22.3442C36.7535 19.7214 34.0581 19.6524 33.3215 19.6524C31.3294 19.6524 29.7055 20.8947 28.6843 20.8947C27.5794 20.8947 26.1229 19.7214 24.3986 19.7214C21.1173 19.7214 17.7858 22.5168 17.7858 27.7969C17.7858 31.0755 19.0247 34.5438 20.5481 36.787C21.8539 38.6851 22.9923 40.2381 24.6329 40.2381Z" fill="white"></path></svg></span>
            <p>Apple</p>
          </button>
          <button type="button" className='social-btn' >
            <span><svg className='social-logo' viewBox="0 0 57 56"><path d="M0.5 28C0.5 12.536 13.036 0 28.5 0C43.964 0 56.5 12.536 56.5 28C56.5 43.464 43.964 56 28.5 56C13.036 56 0.5 43.464 0.5 28Z" fill="#1877F2"></path><path fillRule="evenodd" clipRule="evenodd" d="M28.5 14.2855C20.9256 14.2855 14.7857 20.4253 14.7857 27.9997C14.7857 34.8445 19.801 40.5181 26.3578 41.5467V31.9645H22.8744V27.9997H26.3578V24.9785C26.3578 21.5417 28.404 19.6423 31.5377 19.6423C33.038 19.6423 34.607 19.9111 34.607 19.9111V23.2848H32.8776C31.1743 23.2848 30.6422 24.3421 30.6422 25.4269V27.9997H34.4465L33.839 31.9645H30.6422V41.5467C37.199 40.5181 42.2143 34.8445 42.2143 27.9997C42.2143 20.4253 36.0744 14.2855 28.5 14.2855Z" fill="#fff"></path></svg></span>
            <p >Facebook</p></button>
          <button type="button" className='social-btn' >
            <span><svg className='social-logo' viewBox="0 0 57 56"><path fillRule="evenodd" clipRule="evenodd" d="M41.6657 28.3122C41.6657 27.34 41.5789 26.4044 41.4158 25.5068H28.5V30.8112H35.8813C35.5629 32.5255 34.5968 33.9792 33.1446 34.9514V38.3922H37.5758C40.1693 36.0044 41.6657 32.4889 41.6657 28.3122Z" fill="#3D82F0"></path><path fillRule="evenodd" clipRule="evenodd" d="M28.5003 41.7146C32.2032 41.7146 35.3072 40.4864 37.5761 38.3927L33.1449 34.9504C31.9167 35.7733 30.3457 36.2594 28.5003 36.2594C24.9285 36.2594 21.9053 33.8472 20.8264 30.606H16.2443V34.1595C18.5011 38.6411 23.1396 41.7146 28.5003 41.7146Z" fill="#31A752"></path><path fillRule="evenodd" clipRule="evenodd" d="M20.8261 30.606C20.5518 29.7831 20.3964 28.9039 20.3964 28.0002C20.3964 27.0966 20.5518 26.2174 20.8261 25.3945V21.841H16.244C15.316 23.6924 14.7857 25.7877 14.7857 28.0002C14.7857 30.2128 15.316 32.3081 16.244 34.1595L20.8261 30.606Z" fill="#F9BA00"></path><path fillRule="evenodd" clipRule="evenodd" d="M28.5003 19.7407C30.5133 19.7407 32.322 20.4325 33.7422 21.7917L37.6767 17.8588C35.3011 15.6447 32.1971 14.2855 28.5003 14.2855C23.1396 14.2855 18.5011 17.359 16.2443 21.842L20.8264 25.394C21.9053 22.1529 24.9285 19.7407 28.5003 19.7407Z" fill="#E64234"></path></svg></span>
            <div className='google-logo-border'></div>
            <p>Google</p></button>
          <button type="button" className='social-btn' >
            <span><svg className='social-logo' viewBox="0 0 57 56"><path d="M0.5 28C0.5 12.536 13.036 0 28.5 0C43.964 0 56.5 12.536 56.5 28C56.5 43.464 43.964 56 28.5 56C13.036 56 0.5 43.464 0.5 28Z" fill="#FEE500"></path><path fillRule="evenodd" clipRule="evenodd" d="M28.5 16.2063C21.5606 16.2063 15.9286 20.5812 15.9286 25.9617C15.9286 29.3183 18.1034 32.2474 21.4223 34.0326L20.0269 39.1492C20.0005 39.2509 20.006 39.3583 20.0424 39.4569C20.0788 39.5555 20.1446 39.6406 20.2307 39.7008C20.3169 39.761 20.4195 39.7934 20.5246 39.7937C20.6297 39.7939 20.7324 39.7621 20.8189 39.7023L26.9286 35.6417C27.444 35.6417 27.972 35.7297 28.5 35.7297C35.4394 35.7297 41.0714 31.3549 41.0714 25.9617C41.0714 20.5686 35.4394 16.2063 28.5 16.2063Z" fill="#181600"></path></svg></span>
            <p >Kakao</p></button>
        </div>
        <div className='forget-email'>
          <Link to='/login' style={{color: '#767676'}}>
            계정을 잊으셨나요?
            <FontAwesomeIcon icon={faChevronRight} style={{marginLeft:"6px"}} />
          </Link>
        </div>
        <div className='login-page-divider'></div>
        <div className='policy'>
          <Link to='/login'>이용약관</Link>
          <Link to='/login' style={{marginLeft:"8px"}}>개인정보처리방침</Link></div>
        <div className='en-logo-text'>© Wantedlab, Inc.</div>
        <div className='languege-select-box'>
          <img className='languege-select-img' src='https://static.wanted.co.kr/images/wantedoneid/ico_KR.svg' />
          <select className='languege-select'>
            <option>한국어</option>
            <option>English</option>
            <option></option>
          </select>
        </div>
      </div>
    </div>
  )
}

const SignUpPage = ()=>{
  let navigate = useNavigate();

  // 이메일 받아오기
  let emailInfo = useSelector((state)=>{return state.loginInfo});

  // 가입하기 버튼 스타일
  const [signupBtnStyle, setSignupBtnStyle] = useState(['#ccc','#f2f4f7','','none']);  // 글자색, 배경화면색, cursor, pointerEvents

  // 회원가입 정보
  const [signupInfo, setSignupInfo] =  useState({email:emailInfo, name:"", phoneNumber:"",password:"",
                    fourteenAndOverTF:false, termsAndConditionsTF:false, personalInformationCollectionTF:false,
                    receiveAdvertisementTF:false, receiveEmailAd:false, receiveAppAd:false ,receiveMessageAd:false });


  // 이름 input 변경 함수
  const nameInputChange =(e)=>{
    let inputValue = e.target.value;
    setSignupInfo({
      ...signupInfo,
      [e.target.name]: inputValue
    });
    // console.log(signupInfo);
  }
  // 이름 input 변경 함수
  const phoneNumberInputChange =(e)=>{
    let inputValue = e.target.value;
    setSignupInfo({
      ...signupInfo,
      [e.target.name]: inputValue
    });
    // console.log(signupInfo);
  }

  // 비밀번호 첫번째 칸
  const [password_1, setPassword_1] = useState("");
  const [passwordTextStyle, setpasswordTextStyle] = useState("none");
  const passwordInputChange_1 =(e)=>{
    let inputValue = e.target.value;
    setPassword_1(inputValue)
    // console.log(password_1);
  }
  // 패스워드 변경 함수 - 한번더 입력하는 칸
  const passwordInputChange_2 =(e)=>{
    let inputValue = e.target.value;
    setSignupInfo({
      ...signupInfo,
      [e.target.name]: inputValue
    });

    if(inputValue===password_1 || inputValue.length===0){   // 두번째칸이 빈칸이거나 password_1이랑 같으면
      setpasswordTextStyle("none"); // 안보이게
    } else{
      setpasswordTextStyle("block");
    }

    // console.log(signupInfo);
  }

  // 체크박스 확인 - 14세 이상
  const fourteenAndOverTFCheck = (e)=>{
    let inputValue = e.target.checked;
    setSignupInfo({
      ...signupInfo,
      [e.target.name]: inputValue
    });
  }
  // 체크박스 확인 - 이용약관동의
  const termsAndConditionsTFCheck = (e)=>{
    let inputValue = e.target.checked;
    setSignupInfo({
      ...signupInfo,
      [e.target.name]: inputValue
    });
  }
  // 체크박스 확인 - 개인정보수집
  const personalInformationCollectionTFCheck = (e)=>{
    let inputValue = e.target.checked;
    setSignupInfo({
      ...signupInfo,
      [e.target.name]: inputValue
    });
    // console.log(signupInfo);
  }

  // 가입하기 버튼 조건
  useEffect(()=>{
    if(signupInfo.name.length>=1 && signupInfo.name.length>=1 && signupInfo.phoneNumber.length>=9 &&
      signupInfo.password.length>=3 && signupInfo.fourteenAndOverTF==true && signupInfo.termsAndConditionsTF==true &&
      signupInfo.personalInformationCollectionTF==true && passwordTextStyle=="none"){
      setSignupBtnStyle(['#fff','#36f','pointer','auto'])
    } else{
      setSignupBtnStyle(['#ccc','#f2f4f7','','none']);
    }
  },[signupInfo])


  // 포스트
  const signupSubmit = async(e) =>{

    e.preventDefault();
    const url = 'https://prod.risingserver13forever.shop/app/users';
    const config = {"Content-Type": "application/json" };

    try{
      const data = await axios({
        method:'post',
        url : url,
        data : JSON.stringify(signupInfo),  // JSON.stringify(emailData)
        headers: config,
      })
      console.log(data.data);
      if(data.data.code===1005){ // 가입성공시
        navigate('/login');
      } else{
        alert(data.data.message);
      }
    }
    catch(err){
      alert(err);
    }
  }


  return(
    <div className='login-back'>
      <div className="login-content signup-content">
        <div className='signup-header flex-row'>
          <button className='signup-cancel-btn' onClick={()=>{navigate(-1)}}>취소</button>
          <div className='signup-title'>회원가입</div>
          <div style={{minWidth:"64px"}}></div>
        </div>
        <div className='signup-form-box'>
          <form className='signup-form' onSubmit={signupSubmit}>
            <div className='signup-email-title'>이메일</div>
            <input className='signup-email-input' value={emailInfo} disabled/>
            <div className='signup-email-title'>이름</div>
            <input className='signup-name-input' placeholder='이름을 입력해주세요.' name='name' onChange={nameInputChange} />

            <div className='signup-email-title'>휴대폰 번호</div>
            <select className='country-select'>
              <option>South Korea +82</option>
              <option>Japan +81</option>
              <option>United States +1</option>
            </select>

            <input className='signup-name-input signup-num-input' placeholder='(예시) 01013245768' name='phoneNumber' onChange={phoneNumberInputChange}/>
            <button className='signup-num-btn' style={{pointerEvents:"none"}} >인증번호 받기</button>
            <input className='signup-email-input' placeholder='인증번호를 입력해주세요'/>

            <div className='signup-email-title'>비밀번호</div>
            <input className='signup-name-input' type='password' placeholder='비밀번호를 입력해주세요' name='password_1' onChange={passwordInputChange_1}/>
            <input className='signup-name-input' type='password' placeholder='비밀번호를 다시 한번 입력해주세요' name='password' onChange={passwordInputChange_2}/>
            <p className='signup-password-exactly-test' style={{display:passwordTextStyle}}>비밀번호가 서로 일치하지 않습니다.</p>
            
            <div className='signup-pw-info-text'>
              영문 대소문자, 숫자, 특수문자를 3가지 이상으로 조합해 8자 이상 16자 이하로 입력해주세요
            </div>
            <div className='flex-row total-agree-box'>
              <input type='checkbox' className='signup-checkbox-input'/>
              <div className='agree-title-text'>전체동의</div>
            </div>
            <div className='login-page-divider signup-divider'></div>
            
            <div className='flex-row total-agree-box sub-agree-box'>
              <input type='checkbox' className='signup-checkbox-input' name='fourteenAndOverTF' onChange={fourteenAndOverTFCheck} />
              <div className='agree-title-text agree-sub-title-text'>만 14세 이상입니다.(필수)</div>
            </div>
            <div className='flex-row total-agree-box sub-agree-box'>
              <input type='checkbox' className='signup-checkbox-input'  name='termsAndConditionsTF' onChange={termsAndConditionsTFCheck}/>
              <div className='agree-title-text agree-sub-title-text'>원티드 이용약관 동의(필수)</div>
            </div>
            <div className='flex-row total-agree-box sub-agree-box'>
              <input type='checkbox' className='signup-checkbox-input' name='personalInformationCollectionTF' onChange={personalInformationCollectionTFCheck} />
              <div className='agree-title-text agree-sub-title-text'>원티드 개인정보 수집 및 이용 동의(필수)</div>
            </div>
            <div className='flex-row total-agree-box sub-agree-box'>
              <input type='checkbox' className='signup-checkbox-input'/>
              <div className='agree-title-text agree-sub-title-text'>채용 소식, 커리어 콘텐츠, 이벤트 등 원티드 맞춤 정보 받기</div>
            </div>

            <div className='flex-row' style={{marginLeft:"20px"}}>
              <label className='agree-label'>
                <svg className='agree-check-svg' viewBox="0 0 12 8"><path d="M1.5 4L4.5 7L10.5 1" stroke="#ccc" fill="none" strokeLinecap="round" strokeLinejoin="round"></path></svg>
                <span>이메일</span>
              </label>
              <label className='agree-label'>
                <svg className='agree-check-svg' viewBox="0 0 12 8"><path d="M1.5 4L4.5 7L10.5 1" stroke="#ccc" fill="none" strokeLinecap="round" strokeLinejoin="round"></path></svg>
                <span>앱 푸시</span>
              </label>
              <label className='agree-label'>
                <svg className='agree-check-svg' viewBox="0 0 12 8"><path d="M1.5 4L4.5 7L10.5 1" stroke="#ccc" fill="none" strokeLinecap="round" strokeLinejoin="round"></path></svg>
                <span>문자 메시지</span>
              </label>
            </div>
            <div className='signup-submit-btn-box'>
              <div className='signup-submit-btn-upper'></div>
              <div className='signup-submit-btn-lower'></div>
              <button className='signup-submit-btn' type='submit'
                style={{color:signupBtnStyle[0],backgroundColor:signupBtnStyle[1], cursor:signupBtnStyle[2], pointerEvents:signupBtnStyle[3]}}
                >가입하기
              </button>
            </div>
            
          </form>
        </div>
      </div>
    </div>
  )
}

const PasswordPage = ()=>{
  let navigate = useNavigate();

  // 이메일 받아오기
  let emailInfo = useSelector((state)=>{return state.loginInfo});

  // 패스워드 제출 스타일
  const [passwordBtnStyle, setPasswordBtnStyle] = useState(["#ccc","#f2f4f7","","none"]);

  const [loginValue, setLoginValue] = useState({
    email: '',
    password: '',
  });

  const passwordInputChange =(e)=>{
    let inputValue = e.target.value;
    // console.log(inputValue);
    if(inputValue.length>=1){
      setPasswordBtnStyle(["#fff","#36f","pointer","auto"]);
    } else{
      setPasswordBtnStyle(["#ccc","#f2f4f7","","none"]);
    }
    setLoginValue({
      ...loginValue,
      ['email']:  emailInfo,
      [e.target.name]: inputValue
    });
    // console.log(loginValue);
  }

  const loginSubmit = async(e) =>{

    e.preventDefault();
    const url = 'https://prod.risingserver13forever.shop/app/login';
    const config = {"Content-Type": "application/json" };
    // const exampleValue = {"email":"example@example.com", "password":"example123!"};

    try{
      const data = await axios({
        method:'post',
        url : url,
        data : loginValue,  // JSON.stringify(loginValue)
        headers: config,
      })
      // console.log(data.data);
      if(data.data.code===1002){ // 로그인 성공
        localStorage.setItem('userid',data.data.result.user_id)
        localStorage.setItem('jwt',data.data.result.jwt)
        navigate('/');
      } else{
        alert(data.data.message);
      }
    }
    catch(err){
      alert(err);
    }
  }


  return(
    <div className='login-back'>
      <div className='login-content password-content'>
        <div className='password-header flex-row'>
          <button className='password-header-btn' onClick={()=>{navigate(-1)}}><FontAwesomeIcon icon={faChevronLeft}/></button>
          <div className='password-header-title'>이메일로 로그인</div>
          <div className='password-header-right'></div>
        </div>
        <div className='password-form-box'>
          <form onSubmit={loginSubmit}>
            <div className='password-form-text'>비밀번호</div>
            <input className='password-form-input' type='password' name='password' placeholder='비밀번호를 입력해주세요'
              onChange={passwordInputChange}/>
            <button className='password-form-btn' type='submit' 
              style={{color:passwordBtnStyle[0],backgroundColor:passwordBtnStyle[1], cursor:passwordBtnStyle[2], pointerEvents:passwordBtnStyle[3]}}>
                다음
            </button>
            <button className='password-from-change-btn'>비밀번호 초기화/변경</button>
          </form>
        </div>
      </div>
    </div>
  )
}




export {LoginPage, SignUpPage, PasswordPage};







